import { FC } from "react";

import { CustomProductionButton } from "./custom-production-button";
import { ProduceButtonsPanelTopWrapper } from "./produce-buttons.styled";
import { ProduceButtonsViewModeSwitch } from "./produce-buttons.view-mode.switch";

export const ProduceButtonsTopStatLine: FC = () => {
  return (
    <ProduceButtonsPanelTopWrapper>
      <ProduceButtonsViewModeSwitch />
      <CustomProductionButton />
    </ProduceButtonsPanelTopWrapper>
  );
};
